import {BaseApiTemplateService, Core2Config} from '../../shared';

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {WfIssueSprintContainerModel} from "../../../../../../models/aggregates/wf/issue-sprint";

@Injectable({providedIn: 'root'})
export class WfIssueSprintService extends BaseApiTemplateService<WfIssueSprintContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-sprints/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-sprints/backoffice-ep';
    this.httpClient = http;
  }
}
